import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import logoIcon from "../assets/images/logo-icon.svg";
import { forgotPassword } from "../auth";

const ForgotPassword = () => {
    const { t, i18n } = useTranslation();

    const [email, setEmail] = useState("");
    const [emailSent, setEmailSent] = useState(false);
    const [formError, setFormError] = useState("");
    const [submitButtonIsDisabled, setSubmitButtonIsDisabled] = useState(false);

    const handleLanguageChange = (e) => {
        i18n.changeLanguage(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormError("");
        setSubmitButtonIsDisabled(true);

        try {
            await forgotPassword(email);
            setEmailSent(true);
        } catch (error) {
            setSubmitButtonIsDisabled(false);
            setFormError(t("auth.resetRequestFailed"));
        }
    };

    return (
        <div className="flex justify-center bg-white pt-8 sm:pt-16 px-2 sm:p-2">
            <div className="w-full max-w-md space-y-4 sm:space-y-6 p-4 sm:p-8 border border-gray-200 rounded-xl shadow-sm relative">
                {/* Language Switcher */}
                <div className="absolute top-4 right-4 flex items-center gap-2">
                    <span
                        className={`cursor-pointer ${
                            i18n.language === "en" ? "font-bold" : ""
                        } hover-underline underline-black`}
                        onClick={() => handleLanguageChange({ target: { value: "en" } })}
                    >
                        EN
                    </span>
                    <span>|</span>
                    <span
                        className={`cursor-pointer ${
                            i18n.language === "de" ? "font-bold" : ""
                        } hover-underline underline-black`}
                        onClick={() => handleLanguageChange({ target: { value: "de" } })}
                    >
                        DE
                    </span>
                </div>
                <div className="flex justify-center">
                    <Link to="/">
                        <img src={logoIcon} alt="AusspracheTrainer Logo" className="h-24 w-24" />
                    </Link>
                </div>
                <h2 className="text-center text-2xl text-gray-900">
                    {t("auth.forgotPasswordTitle")}
                </h2>

                {emailSent ? (
                    <>
                        <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg text-sm">
                            {t("auth.resetEmailSent")}
                        </div>
                        <p className="text-center text-sm text-gray-500">
                            <Link to="/login" className="text-purple-500 hover:underline">
                                {t("auth.backToLogin")}
                            </Link>
                        </p>
                    </>
                ) : (
                    <>
                        <p className="text-center text-sm text-gray-500">
                            {t("auth.forgotPasswordDetails")}
                        </p>
                        {formError && (
                            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                                {formError}
                            </div>
                        )}
                        <form className="space-y-4" onSubmit={handleSubmit}>
                            <div>
                                <label
                                    htmlFor="email"
                                    className="block text-sm font-medium text-gray-700 mb-1"
                                >
                                    {t("auth.email")}
                                </label>
                                <input
                                    id="email"
                                    type="email"
                                    placeholder={t("auth.emailPlaceholder")}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg text-sm"
                                    value={email}
                                    onChange={(e) => {
                                        setEmail(e.target.value);
                                        setFormError("");
                                    }}
                                    required
                                />
                            </div>
                            <button
                                disabled={submitButtonIsDisabled}
                                type="submit"
                                className="w-full bg-primary hover:bg-purple-500 text-white py-2 rounded-md"
                            >
                                {t("auth.sendResetLink")}
                            </button>
                        </form>
                        <p className="text-center text-sm text-gray-500">
                            <Link to="/login" className="text-purple-500 hover:underline">
                                {t("auth.backToLogin")}
                            </Link>
                        </p>
                    </>
                )}
            </div>
        </div>
    );
};

export default ForgotPassword;
